import React from "react";
import Weather from "./components/Weather";
import "./App.css";

function App() {
  return (
    <div className="app">
      <Weather />
    </div>
  );
}

export default App;
